import { get, post, postImageAxios } from "helpers/api_helper"
import { put, takeEvery } from "redux-saga/effects"
import { getFormDataFromJSON, showToast } from "utils"
import {
  getLandingDropdownListFailed,
  getLandingDropdownListSuccess,
  getLandingSetupFailed,
  getLandingSetupSuccess,
  updateLandingFeatureOrderFailed,
  updateLandingFeatureOrderSuccess,
  updateLandingSetupFailed,
  updateLandingSetupSuccess,
} from "./actions"
import {
  GET_LANDING_DROPDOWN_LIST,
  GET_LANDING_SETUP,
  UPDATE_LANDING_FEATURE_ORDER,
  UPDATE_LANDING_SETUP,
} from "./actionTypes"

function* getLandingSetup({ payload: params }) {
  try {
    const response = yield get(`/vendor/${params.vendorId}/design/landing`)
    yield put(getLandingSetupSuccess(response))
  } catch (error) {
    yield put(getLandingSetupFailed(error))
    showToast("error", error, "Error")
  }
}

function* getLandingDropdownList({ payload: params }) {
  try {
    const response = yield get("/admin/landing-dropdown-list", params)
    yield put(getLandingDropdownListSuccess(response))
  } catch (error) {
    yield put(getLandingDropdownListFailed(error))
    showToast("error", error, "Error")
  }
}

function* updateLandingSetup({ payload: params }) {
  try {
    let logo = null
    let background = null
    if (params?.uploadLogoImage) {
      logo = yield postImageAxios(
        "/file",
        getFormDataFromJSON(params.logoImage)
      )
    }
    if (params?.uploadBackgroundImage) {
      background = yield postImageAxios(
        "/file",
        getFormDataFromJSON(params.bgImage)
      )
    }

    const response = yield post(
      `/admin/vendor/${params.values?.vendor_id}/design/landing`,
      {
        ...params.values,
        ...(logo ? { logo_file: logo[0] } : {}),
        ...(background
          ? {
              bg_image_file: background[0],
              bg_image_url: null,
              delete_background_image: 1,
            }
          : {}),
      }
    )
    yield put(updateLandingSetupSuccess(response))
    showToast("success", "Saved!", "Success")
  } catch (error) {
    yield put(updateLandingSetupFailed(error))
    showToast("error", error, "Error")
  }
}

function* updateLandingFeatureOrder({ payload: params }) {
  try {
    const response = yield post(
      `/admin/vendor/${params?.vendor_id}/design/landing`,
      params
    )
    yield put(updateLandingFeatureOrderSuccess(response))
  } catch (error) {
    yield put(updateLandingFeatureOrderFailed(error))
    showToast("error", error, "Error")
  }
}

function* landingScreenSaga() {
  yield takeEvery(GET_LANDING_SETUP, getLandingSetup)
  yield takeEvery(GET_LANDING_DROPDOWN_LIST, getLandingDropdownList)
  yield takeEvery(UPDATE_LANDING_SETUP, updateLandingSetup)
  yield takeEvery(UPDATE_LANDING_FEATURE_ORDER, updateLandingFeatureOrder)
}

export default landingScreenSaga
